import { render, staticRenderFns } from "./RecommendModal.html?vue&type=template&id=c590197c&scoped=true&"
import script from "./RecommendModal.vue?vue&type=script&lang=js&"
export * from "./RecommendModal.vue?vue&type=script&lang=js&"
import style0 from "./RecommendModal.scss?vue&type=style&index=0&id=c590197c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c590197c",
  null
  
)

export default component.exports